import { atom } from "jotai";

/**
 * When set to true, the app is in bulk deletion mode.
 */
export const isBulkDeletionModeAtom = atom<boolean>(false);
